import React from 'react';

const Team = (props) => {
  return (
    <h2>Eventually this will be the team page.</h2>
  )};

export default Team;


// WEBPACK FOOTER //
// ./src/Team.js